export enum IDurationEnum {
  HOUR = "hour",
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
  MIN = "min",
}

// The owner of an activity in the shared activities API: an LMS training, or an evaluation template.
export enum ActivityItemTypeEnum {
  TRAINING = "training",
  SESSION_FORM = "sessionForm",
}

// A question's type, as orders names it wherever the question sits: an LMS training, an enquête or a questionnaire.
export enum QuizTypeEnum {
  OPEN_QUESTION = "open_question",
  MULTIPLE_CHOICE_QUESTION = "multiple_choice_question",
  ASSOCIATION_QUESTION = "association_question",
  GAP_FILLING_QUESTION = "gap_filling_question",
  RATING = "rating",
  MULTIPLE_CHOICE_UNSCORED = "multiple_choice_unscored",
}

// A texte à trou read as text and blanks.
export enum QuizGapSegmentKindEnum {
  TEXT = "text",
  GAP = "gap",
}

// Where a video or a document activité comes from, as its editor offers them.
export enum ActivitySourceEnum {
  LINK = "link",
  EMBED = "embed",
  UPLOAD = "upload",
}
